const FORMAT = 'format';
const RESIZE = 'resize';
const CROP = 'cropRadius';
const QUALITY = 'quality';
const BACKGROUND_COLOR = 'backgroundColor';
export { FORMAT, RESIZE, CROP, QUALITY, BACKGROUND_COLOR };